/**
 * Which presentation a phone shows for a region's workshops: the date-ordered
 * list, or the month calendar the wider layouts use.
 *
 * Kept in the address like the rest of Overview's state, so a refresh, or
 * coming back from a workshop opened in the calendar, lands on the same view.
 */
import { useSearchParams } from 'react-router-dom';

export type PhoneWorkshopsLayout = 'list' | 'calendar';

const PARAM = 'workshops';

export function usePhoneWorkshopsLayout(): [
  PhoneWorkshopsLayout,
  (next: PhoneWorkshopsLayout) => void,
] {
  const [params, setParams] = useSearchParams();
  const layout: PhoneWorkshopsLayout = params.get(PARAM) === 'calendar' ? 'calendar' : 'list';

  const setLayout = (next: PhoneWorkshopsLayout) =>
    setParams(
      (prev) => {
        const updated = new URLSearchParams(prev);
        if (next === 'calendar') updated.set(PARAM, next);
        else updated.delete(PARAM);
        return updated;
      },
      { replace: true },
    );

  return [layout, setLayout];
}
